import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import urls from '../../constants/apiurl'
import ApiCaller from '../../constants/ApiCaller'
import { showDangerToast } from '../../constants/toaster'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Box, Chip, Link, Pagination, Typography } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import VideocamIcon from '@mui/icons-material/Videocam'
import Utils from '../../constants/Utils'
import ShowLongText from '../../custom/ShowLongText'

export const AbuseReportsList = (props) => {
  const { formatDate } = Utils()
  const userData = useSelector((state) => state?.userData)
  const [list, setList] = useState(null)
  const [totalItems, setTotalItems] = useState(0)
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  })

  const reportKind = props?.show?.reportKind || props?.reportType || 'PROFILE'
  const isVideo = reportKind === 'VIDEO'

  const getReportAbuseList = async () => {
    try {
      const path = urls.abuseReportList
      const payload = {
        sort: 'createdAt',
        order: true,
        page: pagerecord?.pageNumber - 1,
        limit: pagerecord?.pageSize,
        typeId: props?.show?.typeId
      }
      const res = await ApiCaller.post(payload, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        setList(response?.data)
        setTotalItems(response?.data?.totalItems || 0)
        setPagerecord((prev) => ({
          ...prev,
          totalPages: response?.data?.totalPages || 1,
          totalItems: response?.data?.totalItems || 0
        }))
      } else {
        showDangerToast(response.message)
      }
    } catch (error) {
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleChange = (event, value) => {
    setPagerecord((prev) => ({
      ...prev,
      pageNumber: value
    }))
  }

  useEffect(() => {
    if (props?.show?.typeId) {
      setPagerecord({
        totalItems: 0,
        pageNumber: 1,
        pageSize: 10,
        totalPages: 1
      })
    }
  }, [props?.show?.typeId])

  useEffect(() => {
    if (props?.show?.typeId) {
      getReportAbuseList()
    }
  }, [pagerecord.pageNumber, props?.show?.typeId])

  return (
    <Modal
      show={Boolean(props.show?.typeId)}
      onHide={props.onHide}
      size='lg'
      aria-labelledby='report-abuse-detail-modal'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='report-abuse-detail-modal'>
          {isVideo ? 'Video report details' : 'Profile report details'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box
          sx={{
            mb: 2,
            p: 2,
            borderRadius: 2,
            bgcolor: 'action.hover',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 1.5
          }}
        >
          <Chip
            size='small'
            icon={isVideo ? <VideocamIcon /> : <PersonIcon />}
            label={isVideo ? 'Video' : 'Profile'}
            color={isVideo ? 'warning' : 'primary'}
            variant='outlined'
          />
          <Typography variant='body2'>
            <strong>Reported user:</strong> {props?.show?.userName || '—'}
          </Typography>
          <Typography variant='body2'>
            <strong>User ID:</strong> {props?.show?.userId || '—'}
          </Typography>
          <Chip size='small' color='error' label={`${props?.show?.reportCount ?? 0} total reports`} />
        </Box>

        <div className='table-responsive'>
          <table className='table align-items-center table-flush'>
            <thead className='thead-light'>
              <tr>
                <th scope='col'>#</th>
                <th scope='col'>Reporter</th>
                <th scope='col'>Reporter ID</th>
                <th scope='col'>Date</th>
                <th scope='col'>Reason</th>
                <th scope='col'>Reporter profile</th>
              </tr>
            </thead>
            <tbody>
              {list?.items?.length ? (
                list.items.map((val, ind) => {
                  const rowStart = (pagerecord.pageNumber - 1) * pagerecord.pageSize
                  return (
                    <tr key={val?.id || `${val?.userId}-${ind}`}>
                      <td>{rowStart + ind + 1}</td>
                      <td>{val?.userName || '—'}</td>
                      <td>{val?.userId || '—'}</td>
                      <td>{val?.reportDate ? formatDate(val.reportDate) : '—'}</td>
                      <td>
                        <ShowLongText text={val?.reason} header='Reason' />
                      </td>
                      <td>
                        {(val?.profileLink || val?.userId) ? (
                          <Link
                            href={`/user-manager/${val?.profileLink || val?.userId}`}
                            target='_blank'
                            rel='noopener'
                          >
                            View profile
                          </Link>
                        ) : (
                          '—'
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={6} className='text-center text-muted py-4'>
                    No reporter details found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between align-items-center flex-wrap gap-2'>
        {list?.items?.length > 0 ? (
          <>
            <Typography variant='body2' color='text.secondary'>
              Total: {totalItems}
            </Typography>
            <Pagination
              className='custom-pagination-class'
              count={pagerecord?.totalPages || 1}
              page={pagerecord?.pageNumber}
              onChange={handleChange}
              color='secondary'
              size='small'
            />
          </>
        ) : (
          <span />
        )}
        <Button variant='secondary' onClick={props.onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
